import { render, staticRenderFns } from "./TransactionSummaryTab.vue?vue&type=template&id=3617c214"
import script from "./TransactionSummaryTab.vue?vue&type=script&lang=js"
export * from "./TransactionSummaryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports